export default {
  "content": "<path class=\"path\" d=\"M12 18.485L19.416 23l-1.968-8.51L24 8.764l-8.628-.738L12 0 8.628 8.026 0 8.764l6.552 5.726L4.584 23z\"/>",
  "attrs": {
    "width": "24",
    "height": "23",
    "viewBox": "0 0 24 23",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};